/* eslint-disable */
import { GetterTree } from "vuex";
import { Status } from "@/models/status";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { StatusState } from "@/types/status";

const getters: GetterTree<StatusState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Status();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((status) => Status.toSelectItem(status))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((status) => {
          return status.id == id;
        })
      : new Status();
  },
};

export default getters;
